var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6447_15920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37 0 0 5.37 0 12C0 18.63 5.37 24 12 24C18.63 24 24 18.63 24 12C24 5.37 18.63 0 12 0ZM17.44 12.81H12.8V17.45C12.8 17.89 12.44 18.26 11.99 18.26C11.54 18.26 11.18 17.9 11.18 17.45V12.81H6.54C6.1 12.81 5.73 12.45 5.73 12C5.73 11.55 6.09 11.19 6.54 11.19H11.18V6.55C11.18 6.11 11.54 5.74 11.99 5.74C12.44 5.74 12.8 6.1 12.8 6.55V11.19H17.44C17.88 11.19 18.25 11.55 18.25 12C18.25 12.45 17.89 12.81 17.44 12.81Z",
    fill: "#028383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6447_15920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateActiveIcon);
export default __webpack_public_path__ + "static/media/createActiveIcon.d966bc1681fedb9ca3675e1affd2c365.svg";
export { ForwardRef as ReactComponent };